module.exports = __webpack_public_path__ + "img/14.3ec0aae3.png";